var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrLeidos = function SvgQrLeidos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "qr_leidos_svg__Capa_2",
    viewBox: "0 0 14.66 11.11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_leidos_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.16,
    height: 3.21,
    x: -0.71,
    y: 6.07,
    rx: 1.56,
    ry: 1.56,
    transform: "rotate(45 3.379 7.68)",
    fill: "#22aa9f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.33,
    height: 3.21,
    x: 1.94,
    y: 3.95,
    rx: 1.56,
    ry: 1.56,
    transform: "rotate(-45 9.111 5.556)",
    fill: "#2ad2c5"
  }))));
};
export default SvgQrLeidos;